import React from "react";
import { Box, Typography } from "@mui/material";

interface PublicUserInfoProps {
  userData: {
    displayName: string;
    joinDate: string;
    profileBio: string;
  } | null;
  profileUserId?: string;
}

function PublicUserInfo({ userData }: PublicUserInfoProps) {

  return (
    <Box sx={{ p: 3 }}>
      {userData ? (
        <>
          <Typography variant="h5" color="primary" gutterBottom>
            User Info
          </Typography>

          {/* Display Name */}
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>Display name:</strong> {userData.displayName}
          </Typography>

          {/* Join Date */}
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>Join Date:</strong> {userData.joinDate}
          </Typography>

          {/* Bio Section */}
          <Typography variant="h6" color="primary" gutterBottom>
            Bio
          </Typography>
          <Typography component="div">
            <Box sx={{ fontWeight: "light", p: 1, bgcolor: "grey.50", borderRadius: 1 }}>
              <div
                className="player-bio"
                dangerouslySetInnerHTML={{
                  __html: userData.profileBio,
                }}
              />
            </Box>
          </Typography>
        </>
      ) : (
        <Typography variant="body1" color="text.secondary">
          No user information available
        </Typography>
      )}
    </Box>
  );
}

export default PublicUserInfo;
